<template>
  <div>
    <div class="d-flex justify-content-between mb-1">
      <h4>{{ labelTitle }}</h4>
    </div>

    <b-row v-for="(item, key) in contacts" :key="key">
      <b-col cols="6" md="3">
        <b-form-group>
          <b-form-input v-model="item.contactTypeDesc" :plaintext="true"  />
        </b-form-group>
      </b-col>
      <b-col cols="6" md="3">
        <b-form-group>
          <b-form-input
            v-model="item.description"
            :plaintext="true" 
            placeholder="กรุณากรอก ข้อมูลติดต่อ"
          />
        </b-form-group>
      </b-col>      
    </b-row>
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BButton,
  BFormInput,
  BFormGroup,
  BFormSelect,
} from "bootstrap-vue";

import { ValidationObserver, ValidationProvider, extend } from "vee-validate";
import * as storeMaster from "@/store/api/master/index.js";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BButton,
    BFormInput,
    BFormGroup,
    BFormSelect,
    ValidationProvider,
  },
  props: {
    labelTitle: "",
    contacts: [],
  },
  data() {
    return {
      contactTypes: [],
    };
  },
  methods: {
    
  },
};
</script>

<style></style>
